/**
 * Who set a document's subject-matter labels: the classifier, or a person correcting it.
 *
 * Numbers, like `DocumentClassificationStatus`, because the API serializes enums as integers.
 * `Automatic` is 0, so test it with `===` rather than for truthiness.
 */
export enum DocumentClassificationSource {
  Automatic = 0,
  ManualOverride = 1,
}
